import DOMPurify from 'dompurify';

// Permissive sanitization: admin-authored content is trusted, but we strip the
// obviously dangerous while keeping embeds (iframes) intact.
export function sanitizeHtml(html) {
  return DOMPurify.sanitize(html || '', {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling', 'target'],
  });
}

// Groups a flat category list into a two-level tree.
export function buildCategoryTree(categories = []) {
  const parents = categories.filter((c) => !c.parentId);
  return parents.map((parent) => ({
    ...parent,
    children: categories.filter((c) => c.parentId === parent.id),
  }));
}
